import { useEffect, useState } from "react";
import AdminDashboard from "@/pages/AdminDashboard";
import { adminApi, authApi, startGoogleLogin } from "@/lib/admin";

// Post-Google-Auth: /admin is a plain protected route. If the caller isn't
// authenticated we redirect to Google login. The old wedding_code login
// screen has been removed.
export default function Admin() {
    const [state, setState] = useState({
        status: "checking", // checking | authed
        wedding: null,
    });

    // Session bootstrap on mount.
    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const data = await adminApi.session();
                if (!cancelled) setState({ status: "authed", wedding: data });
            } catch (e) {
                if (e?.response?.status === 401) {
                    startGoogleLogin("/admin");
                    return;
                }
                console.error("admin session check failed", e);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    if (state.status === "checking") {
        return (
            <div className="h-[100dvh] w-full flex items-center justify-center text-[var(--ink-soft)] text-sm">
                Comprobando sesión...
            </div>
        );
    }

    return (
        <AdminDashboard
            wedding={state.wedding}
            onLogout={async () => {
                try {
                    await authApi.logout();
                } catch (err) {
                    console.warn("logout request failed", err);
                }
                startGoogleLogin("/admin");
            }}
        />
    );
}
